import { ProductVariant } from 'app/(main)/(catalog)/upload/[slug]/_components/designUpload/types'
import Cookie from 'js-cookie'
import { COOKIE_HUBSPOT } from '@utils/constants'

export const PDP_PAGE_POPUP_TEST_IDS = {
  V1_OFFLINE: 'v1-offline',
  V2_ONLINE: 'v2-online',
  V3_COMMUNITY: 'v3-community',
}

export const productOptionToHubspotPayload = ({
  productOption,
  customQuantity,
  productName,
  productSlug,
  correspondingPlusProductSku,
}: {
  productOption: ProductVariant
  customQuantity: string | number
  productName: string
  productSlug: string
  correspondingPlusProductSku: string
}) => {
  const optionFields = productOption?.optionsValues
    ?.map((option) => {
      if (option?.option_display_name.toLowerCase() !== 'quantity') {
        return {
          name: option?.option_display_name.toLowerCase()?.replaceAll(' ', '_'),
          value: option?.label?.toLowerCase(),
          label: option?.option_display_name,
        }
      }
      return null
    })
    .filter(Boolean)

  return {
    fields: [
      {
        name: 'line_items',
        label: 'Line Items',
        value: [
          {
            fields: [
              ...optionFields,
              {
                name: 'custom_quantity',
                label: 'Custom Quantity',
                value: String(customQuantity),
              },
              {
                name: 'product_slug',
                label: 'Product Slug',
                value: productSlug,
              },
              {
                name: 'variant_sku',
                label: 'Variant SKU',
                value: correspondingPlusProductSku,
              },
              {
                name: 'product_name',
                label: 'Product Name',
                value: productName,
              },
              {
                name: 'image_url',
                label: 'Image URL',
                value: productOption?.imageUrl,
              },
              {
                name: 'page_url',
                label: 'Page URL',
                value: `${window?.location?.origin}${window?.location?.pathname}`,
              },
            ],
          },
        ],
      },
    ],
    context: {
      hutk: Cookie.get(COOKIE_HUBSPOT),
    },
  }
}
